/* eslint-disable react/jsx-pascal-case */
import { useContext, useEffect, useRef, useState } from "react";
import GeneralContext from "../../../../context/GeneralContext/GeneralContext";
import api from "../../../../services/api";
import SL_Button from "../../../../components/buttons/Button";
import { SL_Input } from "../../../../components/input/Input";
import { Checkbox, Form, Image, Modal, Skeleton } from "antd";
import EContentTypes from "../../../../enums/EContentTypes";
import { SL_Select } from "../../../../components/selects/Select";
import { SL_HtmlEditor } from "../../../../components/htmlEditor/HtmlEditor"
import { useParams } from "react-router-dom";
import { displayMessage } from "../../../../helpers/messages";
import { ERegExp } from "../../../../enums/ERegExp";
import { SL_Upload } from "../../../../components/upload/Upload";
import { UploadOutlined } from "@ant-design/icons";
import { formatImageBeforeSend } from "./CreateContentModal";


export function DetailContentModal({ onCloseModal, idContent, reloadGridData }) {
	const { idDay } = useParams();
	const [form] = Form.useForm()
	const editorRef = useRef()

	const [content, setContent] = useState(null)
	const [categories, setCategories] = useState([])
	const [EContentTypes, setEContentType] = useState();
	const [isLoading, setIsLoading] = useState(true);
	const [readOnly, setReadOnly] = useState(true);
	const [changeImage, setChangeImage] = useState(false);

	const type = Form.useWatch('type', form)

	const { setShowLoading, mobile_mode, loggedUser } = useContext(GeneralContext);

	useEffect(() => {
		setTimeout(() => {
			loadData();
		}, 500)
	}, []);

	async function loadData() {
		try {
			const { data: eContentTypes } = await api.enums.find("EContentTypes");
			setEContentType(eContentTypes);

			const { data: categories } = await api.categories.list()
			let formatedCategories = categories?.map(({ id, description }) => ({ value: id, label: description })) ?? []
			setCategories(formatedCategories)

			const { data: content } = await api.content.find(idContent);
			form.setFieldsValue(content)
			setContent(content)
		} finally {
			setIsLoading(false);
		}
	}

	async function formatValuesBeforeSend(values) {
		let valuesToFormat = { ...values }

		if (valuesToFormat.type == EContentTypes.TEXT.code) {
			valuesToFormat.text = editorRef.current.getEditorInnerText()
			valuesToFormat.html_text = editorRef.current.getEditorInnerHTML()
		} else if (valuesToFormat.type == EContentTypes.IMAGE.code) {
			if (changeImage) {
				valuesToFormat = await formatImageBeforeSend(valuesToFormat, loggedUser?.id)
			} else {
				const { image_id } = content
				valuesToFormat = { ...valuesToFormat, image_id, }
			}
		}

		return valuesToFormat
	}

	async function onFinishForm(values) {
		const formattedValues = await formatValuesBeforeSend(values)

		if (!formattedValues) {
			alert('Erro ao formatar conteúdo. ', 'error', 'ERROR')
			return
		}

		try {
			setShowLoading(true)

			const { data } = await api.content.update(idContent, formattedValues)
			form.setFieldsValue(data)
			setContent(data)

			await reloadGridData()

			setReadOnly(true)
		} finally {
			setTimeout(() => {
				setShowLoading(false)
			}, 750)
		}
	}

	function onClickSaveContent() {
		form.submit()
	}

	function onRemoveImage() {
		setChangeImage(true)
	}


	return (
		<Modal
			title={<div className="text-xl font-bold text-fit-red-900 mr-3">{displayMessage('VIEW_CONTENT_2')}</div>}
			open={true}
			onCancel={onCloseModal}
			centered={true}
			footer={
				<div className='flex flex-col sm:flex-row gap-2 justify-end'>
					<SL_Button
						variant={'close'}
						className="w-full sm:min-w-[150px] sm:w-[150px]"
						onClick={onCloseModal}
					>
						{displayMessage('CLOSE')}
					</SL_Button>

					{
						readOnly ? (
							<SL_Button
								className="w-full sm:min-w-[150px] sm:w-[150px] m-0"
								onClick={() => { setReadOnly(false) }}
							>
								{displayMessage('EDIT')}
							</SL_Button>
						) : (
							<SL_Button
								variant={'secondary'}
								className="w-full sm:min-w-[150px] sm:w-[150px]"
								onClick={onClickSaveContent}
							>
								{displayMessage('SAVE')}
							</SL_Button>
						)
					}
				</div>
			}
			maskClosable={false}
			width={750}
			form={form}
		>
			<Form
				onFinish={onFinishForm}
				layout="vertical"
				form={form}
				className={`flex gap-2 flex-col`}
				disabled={readOnly}
			>
				{
					isLoading ? (
						<Skeleton active />
					) : (
						<>
							<Form.Item
								label={<span className='text-fit-red-900 font-semibold'>{displayMessage('TITLE')}:</span>}
								name="title"
								className={`w-full m-0`}
								required
								rules={[
									{ required: true, message: displayMessage('TITLE_MANDATORY') },
									{ pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
									{ whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
								]}
								initialValue={""}
							>
								<SL_Input type="text" className='text-fit-red-900' />
							</Form.Item>

							<Form.Item
								label={<span className='text-fit-red-900 font-semibold'>{displayMessage('DESCRIPTION')}:</span>}
								name="description"
								className={`w-full m-0`}
								rules={[
									{ pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
									{ whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
								]}
								initialValue={""}
							>
								<SL_Input textarea={true} rows={4} showCount maxLength={2000} type="text" className='text-fit-red-900' />
							</Form.Item>
							

							<div className="gap-4 flex w-full flex-col smb:flex-row mt-2">
								<Form.Item
									label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CATEGORY')}:</span>}
									name="category_id"
									className={`w-full m-0`}
									initialValue={null}
									required
									rules={[{ required: true, message: displayMessage('CATEGORY_MANDATORY') }]}
								>
									<SL_Select options={categories} />
								</Form.Item>

								<Form.Item
									label={<span className='text-fit-red-900 font-semibold'>{displayMessage('TYPE')}:</span>}
									name={"type"}
									className={`w-full m-0`}
									required
									initialValue={EContentTypes.IMAGE.value}
								>
									<SL_Select disabled options={Object.values(EContentTypes).map(({ code, description }) => ({ value: code, label: description }))} />
								</Form.Item>

								<Form.Item
									label={<span className='text-fit-red-900 font-semibold'>{displayMessage('ORDER_CODE')}:</span>}
									name={"order_code"}
									className={`w-full m-0`}
									required
									initialValue={0}
								>
									<SL_Input type="number" className='text-fit-red-900' />
								</Form.Item>

								{/* <Form.Item
                                    name={"is_free"}
                                    valuePropName="checked"
                                    className={`m-0`}
                                    style={{ width: 210 }}
                                >
                                    <Checkbox style={{ marginTop: 15 }}>
                                        Conteúdo gratuito?
                                    </Checkbox>
                                </Form.Item> */}
							</div>


							<DetailContentType
								readOnly={readOnly}
								type={type}
								content={content}
								initialText={content.html_text}
								editorRef={editorRef}
								changeImage={changeImage}
								onRemoveImage={onRemoveImage}
							/>
						</>
					)
				}
			</Form>
		</Modal>
	);
}

function DetailContentType({ readOnly, type, content, initialText, editorRef, changeImage, onRemoveImage }) {
	//Criado apenas para component não quebrar. Valores estão sendo pegos da ref.
	const [text, setText] = useState(initialText)

	function customRequest({ file, onSuccess }) {
		setTimeout(() => {
			onSuccess()
		}, 500)
	}

	if (type == EContentTypes.IMAGE.value) {
		if (readOnly) {
			return (
				<div className="flex justify-center mt-1">
					<div className="w-96 rounded-md overflow-hidden">
						<Image width={'100%'} src={content.Attachment.fullUrl}></Image>
					</div>
				</div>
			);
		}

		if (!changeImage) {
			return (
				<SL_Button onClick={onRemoveImage} danger={true}>Remover Image</SL_Button>
			)
		}

		return (
			<Form.Item
				label={''}
				name={"image"}
				className={`w-full m-0 mt-2`}
				initialValue={null}
				required
			>
				<SL_Upload maxCount={1} listType="picture" customRequest={customRequest}>
					<SL_Button icon={<UploadOutlined />}>{displayMessage('LOAD_IMAGE')}</SL_Button>
				</SL_Upload>
			</Form.Item>
		)
	}

	if (type == EContentTypes.VIDEO.value) {
		if (readOnly) {
			return (
				<div
					style={{
						flex: 1,
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<iframe
						width="100%"
						// width="560" original
						// height="315"
						// height={mobile_mode ? "200px" : "400px"}
						src={content.iframe_video_url}
						title="YouTube video player"
						frameBorder="0"
						allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
						allowFullScreen
						style={{ aspectRatio: 560 / 315 }}
					/>
				</div>
			)
		}

		return (
			<Form.Item
				label={<span className='text-fit-red-900 font-semibold'>{displayMessage('VIDEO_LINK')}:</span>}
				name={'video_url'}
				className={`w-full m-0 mt-2`}
				initialValue={''}
				required
			>
				<SL_Input type={"url"} />
			</Form.Item>
		);
	}

	if (type == EContentTypes.TEXT.value) {
		if (readOnly) {
			return (
				<div className="overflow-auto w-full mt-2">
					<div className="min-w-[400px] w-full h-[200px]">
						<SL_HtmlEditor  toolbarHidden ref={editorRef} value={text} readOnly={true}/>
					</div>
				</div>
			)
		}

		return (
			<div className="overflow-auto w-full mt-2">
				<div className="min-w-[400px] w-full h-[200px]">
					<SL_HtmlEditor ref={editorRef} value={text} />
				</div>
			</div>
		)
	}

	return <></>
}